<script lang="ts">
  import {
    Button,
    Grid,
    InlineNotification,
    Loading,
    Tile,
  } from "carbon-components-svelte";

  // import "carbon-components-svelte/css/white.css";
  // import "carbon-components-svelte/css/g100.css";
  import "./App.scss";
  import CategorySelector from "./CategorySelector.svelte";
  import Fields from "./components/preview/Fields.svelte";
  import APIClient from "./ts/APIClient";
  import type { ICanvas } from "./ts/Interfaces";
  import { NCFields } from "./ts/NCFields";

  import { optionsData, layoutId, settingsElementId } from "./ts/Stores";

  const ncfields: NCFields = NCFields.Instance();
  settingsElementId.subscribe((value) => {
    ncfields.updateSettingsFieldId(value);
  });

  let client: APIClient = null;
  let load = async (): Promise<ICanvas> => {
    client = new APIClient(ncfields.wizData["apiUri"]);
    return await client
      .fetchOptions(ncfields.fetchingId)
      .then(async (options) => {
        optionsData.set(options);
        layoutId.set(options.layoutOptions.defaultLayoutId);
        disableLayoutChange = false;
        return await onLayoutChange(options.layoutOptions.defaultLayoutId);
      });
  };

  let selectedLayoutId: string = null;
  let disableLayoutChange: boolean = true;
  let onLayoutChange = async (value: string): Promise<ICanvas> => {
    selectedLayoutId = value;
    if (ncfields.editMode) return ncfields.getSettings();
    return (
      selectedLayoutId !== undefined &&
      selectedLayoutId !== null &&
      (await client.fetchLayout(selectedLayoutId))
    );
  };

  layoutId.subscribe((value) => {
    if (!disableLayoutChange) {
      canvasPromise = onLayoutChange(value);
    }
  });

  let canvasPromise: Promise<ICanvas> = load();
  async function reload() {
    canvasPromise = load();
  }
</script>

{#await canvasPromise}
  <Loading description="Loading editor..." />
{:then canvas}
  <CategorySelector {canvas} {client} />
{:catch error}
  <Grid noGutter>
    <Tile>
      <InlineNotification
        hideCloseButton
        kind="error"
        title="Error Loading Wizard"
        subtitle={error.message}
      />
      <Button on:click={reload}>Retry</Button>
    </Tile>
  </Grid>
{/await}
<Fields />
